<template>
  <div class="fee-info">
    <!-- <div class="fee-info__item">
      <span>{{ $t("fee.service_fee") }}</span>
      <div>
        <vue-numeric
          :currency="feeDetail.currency_symbol"
          v-model="feeDetail.distance_price"
          read-only
          data-test-id="value_service_fee"
        ></vue-numeric>
      </div>
    </div> -->
    <div class="fee-info__item" v-if="feeDetail.hour_fee && feeDetail.hour_fee > 0">
      <span>{{ $t('fee.hour_fee') }}</span>
      <div>
        <vue-numeric
          :currency="feeDetail.currency_symbol"
          v-model="feeDetail.hour_fee"
          read-only
          data-test-id="value_service_fee"
        ></vue-numeric>
      </div>
    </div>
    <div class="fee-info__item" v-if="feeDetail.item_fee > 0">
      <span>{{ $t('fee.total_item_price') }}</span>
      <div>
        <vue-numeric
          :currency="feeDetail.currency_symbol"
          v-model="feeDetail.item_fee"
          read-only
          data-test-id="value_service_fee"
        ></vue-numeric>
      </div>
    </div>
    <div class="fee-info__item" v-if="feeDetail.distance_price && feeDetail.distance_price > 0">
      <span>{{ $t('fee.delivery_fee') }}</span>
      <div>
        <vue-numeric
          :currency="feeDetail.currency_symbol"
          v-model="feeDetail.distance_price"
          read-only
          data-test-id="value_service_fee"
        ></vue-numeric>
      </div>
    </div>
    <!-- Case: have requests && special_request_price -->
    <div
      class="fee-info__item"
      :class="{ 'request-fee': showRequestDetail }"
      v-if="feeDetail.requests && feeDetail.requests.length > 0"
    >
      <span @click="handleExpandRequestDetail">
        {{ $t('fee.service_fee') }}
        <SvgIcon
          v-if="showRequestDetail"
          class="icon"
          height="8"
          width="12"
          :icon="requestExpand ? 'ArrowUp' : 'ArrowDown'"
        />
      </span>
      <div>
        <vue-numeric
          :currency="feeDetail.currency_symbol"
          v-model="feeDetail.special_request_price"
          read-only
          name="value_request_fee"
        ></vue-numeric>
      </div>
    </div>
    <!-- Case: empty request && have special_request_price -->
    <div
      class="fee-info__item"
      :class="{ 'request-fee': showRequestDetail }"
      v-else-if="feeDetail.requests.length === 0 && feeDetail.special_request_price"
    >
      <span @click="handleExpandRequestDetail">
        {{ $t('fee.service_fee') }}
      </span>
      <div>
        <vue-numeric
          :currency="feeDetail.currency_symbol"
          v-model="feeDetail.special_request_price"
          read-only
          name="value_request_fee"
        ></vue-numeric>
      </div>
    </div>

    <div class="fee-info__request-detail" v-if="requestExpand">
      <div v-for="request in feeDetail.requests" :key="request._id" class="fee-info__request-item">
        <div>
          <span>{{ request.name_label }}</span>
          <p
            class="fee-info__request-description"
            v-if="request.type === $constants.SERVICE_REQUESTS.TIER"
          >
            {{ request.title_tier }} - {{ request.description }}
          </p>
          <p
            class="fee-info__request-description"
            v-if="request._id.includes($constants.SERVICE_REQUESTS.FRAGILE)"
          >
            {{ request.description }}
          </p>
          <span v-if="request.num && request.type !== 'ITEM'">&nbsp;(x{{ request.num }})</span>
        </div>
        <div>
          <vue-numeric
            :currency="feeDetail.currency_symbol"
            v-model="request.price"
            read-only
            name="item_price"
          ></vue-numeric>
        </div>
      </div>
    </div>
    <div class="fee-info__item" v-if="feeDetail.stoppoint_price > 0">
      <span>{{ $t('fee.additional_stop_surcharge') }}</span>
      <div>
        <vue-numeric
          :currency="feeDetail.currency_symbol"
          v-model="feeDetail.stoppoint_price"
          read-only
          data-test-id="value_service_fee"
        ></vue-numeric>
      </div>
    </div>
    <div class="fee-info__item" v-if="feeDetail.premium_service_fee > 0">
      <span
        >{{ $t('fee.premium_service_fee') }}
        <v-tooltip bottom max-width="240">
          <v-icon size="16" slot="activator">info_outline</v-icon>
          <span>{{ $t('fee.premium_service_fee_tooltip') }}</span>
        </v-tooltip>
      </span>
      <div>
        <vue-numeric
          :currency="feeDetail.currency_symbol"
          v-model="feeDetail.premium_service_fee"
          read-only
          data-test-id="premium_service_fee"
        ></vue-numeric>
      </div>
    </div>

    <v-divider v-if="feeDetail.vat > 0"></v-divider>

    <div class="fee-info__item" v-if="feeDetail.vat > 0">
      <span>{{ $t('fee.vat') }}</span>
      <div>
        <vue-numeric
          :currency="feeDetail.currency_symbol"
          v-model="feeDetail.vat"
          read-only
          name="value_vat"
        ></vue-numeric>
      </div>
    </div>
    <!-- <div class="fee-info__item" v-if="feeDetail.subtotal_price > 0">
      <span>{{ $t("fee.sub_total") }}</span>
      <div>
        <vue-numeric
          :currency="feeDetail.currency_symbol"
          :value="feeDetail.subtotal_price"
          read-only
          name="value_sub_total"
        ></vue-numeric>
      </div>
    </div> -->

    <template v-if="discountDetails.length > 0">
      <div class="discount-wrapper">
        <div class="fee-info__item" v-for="(discount, idx) in discountDetails" :key="idx">
          <div class="discount-title">
            <img src="/assets/images/icons/TagPromo.svg" alt="promo-tag" width="16" height="16" />
            <p class="discount-name">
              {{ discount.description || discount.promo_code_id }}
            </p>
          </div>
          <div class="discount-value">
            -&nbsp;
            <vue-numeric
              :currency="feeDetail.currency_symbol"
              :value="discount.discount_value"
              read-only
              data-test-id="value_service_fee"
            ></vue-numeric>
          </div>
        </div>
      </div>
    </template>

    <!-- <div class="fee-info__item" v-if="feeDetail.item_discount > 0">
      <span>{{ $t("fee.item_discount") }}</span>
      <div class="red--text">
        -&nbsp;
        <vue-numeric
          :currency="feeDetail.currency_symbol"
          :value="feeDetail.item_discount"
          read-only
        ></vue-numeric>
      </div>
    </div> -->

    <v-divider></v-divider>
    <div
      v-if="feeDetail.payment_details && feeDetail.payment_details.icon_url"
      class="fee-info__item fee-total"
    >
      <div class="fee-info__tilte">
        <div>{{ $t('fee.total_payment') }}</div>
        <div class="fee-sub">{{ $t('fee.vat_included') }}</div>
      </div>
      <div :title="paymentMethodDesc">
        <img :src="feeDetail.payment_details.icon_url" width="25" height="25" />
        <vue-numeric
          :currency="feeDetail.currency_symbol"
          :value="feeDetail.total_price"
          read-only
          data-test-id="valueTotalFee"
        ></vue-numeric>
      </div>
    </div>
    <div v-else class="fee-info__item fee-total">
      <div class="fee-info__tilte">
        <div>{{ $t('fee.total_payment') }}</div>
        <div class="fee-sub">{{ $t('fee.vat_included') }}</div>
      </div>
      <div :title="paymentMethodDesc">
        <img :src="paymentMethodIcon" width="25" height="25" />
        <vue-numeric
          :currency="feeDetail.currency_symbol"
          :value="feeDetail.total_price"
          read-only
          data-test-id="valueTotalFee"
        ></vue-numeric>
      </div>
    </div>
    <v-divider v-if="totalCOD || sumCODOfFailedStoppoints"></v-divider>
    <div class="fee-info__item fee-other" v-if="totalCOD || sumCODOfFailedStoppoints">
      <span>{{ $t('fee.other') }}</span>
    </div>
    <div class="fee-info__item cod-total" v-if="totalCOD">
      <span>{{ $t('fee.cod') }}</span>
      <div>
        <vue-numeric
          :currency="feeDetail.currency_symbol"
          :value="totalCOD"
          read-only
          name="value_total_cod"
        ></vue-numeric>
      </div>
    </div>
    <div class="fee-info__item cod-total" v-if="sumCODOfFailedStoppoints">
      <span>{{ $t('fee.total_cod_return') }}</span>
      <div>
        <vue-numeric
          :currency="feeDetail.currency_symbol"
          :value="sumCODOfFailedStoppoints"
          read-only
        ></vue-numeric>
      </div>
    </div>
    <ReimbursementFeeModal
      v-if="showReimbursement"
      :orderId="feeDetail._id"
      :reimbursement="feeDetail.reimbursement"
      :currency="feeDetail.currency_symbol"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
const { merge, find, groupBy, sumBy } = require('@/plugins/lodash')
import ReimbursementFeeModal from '@/components/record_detail_v2/reimbursement/ReimbursementFeeModal.vue'

export default {
  name: 'FeeDetailV2',
  components: {
    ReimbursementFeeModal
  },
  props: {
    estimatedFee: {
      type: Object
    },
    showRequestDetail: {
      type: Boolean,
      default: true
    },
    requests: {
      type: Array,
      default: () => []
    },
    totalCOD: {
      type: Number
    },
    sumCODOfFailedStoppoints: {
      type: Number
    },
    isShowReimbursement: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      requestExpand: false
    }
  },
  computed: {
    ...mapGetters(['localeSuffix']),
    feeDetail() {
      let result = Object.assign({}, this.estimatedFee)

      result.currency_symbol = this.$constants.CURRENCY_SYMBOL[result.currency]

      // Map request name
      if (this.showRequestDetail && result.requests && result.requests.length > 0) {
        if (this.requests && this.requests.length > 0) {
          result.requests.forEach((request) => {
            const orgReq = find(this.requests, { _id: request._id })
            const copyOrgReq = Object.assign({}, orgReq, request)
            merge(request, copyOrgReq)

            request.name_label = request['name' + this.$store.getters.localeSuffix] || request.name

            if (request.type === this.$constants.SERVICE_REQUESTS.TIER) {
              let tier = request.tier_list.find((e) => e.code === request.tier_code)
              request.description =
                tier['description' + this.$store.getters.localeSuffix] || tier.description

              request.title_tier =
                tier['name' + this.$store.getters.localeSuffix] || tier.title_tier
            }

            if (request._id.includes(this.$constants.SERVICE_REQUESTS.FRAGILE)) {
              let fragile = request.options.find((o) => o.code === request.option_code)

              request.description =
                request.option_code === request.options[request.options.length - 1].code
                  ? request.option_detail
                  : fragile['name' + this.localeSuffix] || ''
            }
          })

          // merge same _id requests
          let uniqRequests = []
          const grouped = groupBy(result.requests, '_id')
          for (let key in grouped) {
            if (grouped[key].length > 1) {
              uniqRequests.push({
                _id: key,
                ...grouped[key][0],
                price: sumBy(grouped[key], 'price'),
                description: grouped[key][0].tier_code,
                num: grouped[key].length
              })
            } else {
              uniqRequests.push(grouped[key][0])
            }
          }
          result.requests = uniqRequests
        }
      }
      return result
    },
    paymentMethodIcon() {
      switch ((this.feeDetail && this.feeDetail.payment_method) || '') {
        case this.$constants.PAYMENT_METHODS.CASH:
          return '/assets/images/icons/Cash.svg'
        case this.$constants.PAYMENT_METHODS.CASH_BY_RECIPIENT:
          return '/assets/images/icons/CashByRecipient.svg'
        case this.$constants.PAYMENT_METHODS.BALANCE:
          if (this.feeDetail.is_child_account || this.feeDetail.is_postpaid) {
            return '/assets/images/icons/Corporate.svg'
          }
          return '/assets/images/icons/PersonalBalance.svg'
        case this.$constants.PAYMENT_METHODS.MOMO:
          return '/assets/images/icons/Momo.svg?ver=1'
        case this.$constants.PAYMENT_METHODS.ZALOPAY:
          return '/assets/images/icons/ZaloPayIcon.svg?ver=1'
        // case this.$constants.PAYMENT_METHODS.SMARTPAY:
        //   return '/assets/images/logo_SmartPay.png?ver=1'
        case this.$constants.PAYMENT_METHODS.VIETTELPAY:
          return 'https://ahamoveimg.s3-ap-southeast-1.amazonaws.com/Logo+Partners/Logo_ViettelPay.png?ver=1'
        case this.$constants.PAYMENT_METHODS.SHOPEEPAY:
          return 'https://ahamoveimg.s3.ap-southeast-1.amazonaws.com/Logo+Partners/Logo_ShopeePay.png?ver=1'
        case this.$constants.PAYMENT_METHODS.CARD:
          return (
            (this.estimatedFee.payment_details && this.estimatedFee.payment_details.icon_url) ||
            '/assets/images/icons/Cash.svg'
          )
        case this.$constants.PAYMENT_METHODS.BUSINESS_ACCOUNT:
          return '/assets/images/icons/BusinessAccount.svg'
        default:
          return '/assets/images/icons/Cash.svg'
      }
    },
    paymentMethodDesc() {
      switch ((this.feeDetail && this.feeDetail.payment_method) || '') {
        case this.$constants.PAYMENT_METHODS.CASH:
          return this.$t('fee.pay_by_cash')
        case this.$constants.PAYMENT_METHODS.BALANCE:
          return this.$t('fee.pay_by_account')
        case this.$constants.PAYMENT_METHODS.MOMO:
          return this.$t('fee.pay_by_momo')
        case this.$constants.PAYMENT_METHODS.BUSINESS_ACCOUNT:
          return this.$t('fee.pay_by_business')
        default:
          return this.$t('fee.pay_by_cash')
      }
    },
    partnerOnwheel() {
      return Boolean(
        this.$_VUE_APP_DOMAIN.includes(this.$constants.DOMAIN.ONWHEEL) ||
          this.$_PAGE === this.$constants.PAGE.PARTNER
      )
    },
    showReimbursement() {
      if (!this.feeDetail.reimbursement || this.partnerOnwheel) {
        return false
      }

      const isOrderCompleted =
        this.estimatedFee &&
        this.estimatedFee.status &&
        this.estimatedFee.status === this.$constants.ORDER_STATUS.COMPLETED

      return isOrderCompleted ? this.isShowReimbursement : true
    },
    discountDetails() {
      return this.feeDetail.discount_details || []
    }
  },
  methods: {
    handleExpandRequestDetail() {
      this.requestExpand = !this.requestExpand
    }
  }
}
</script>

<style lang="scss" scoped>
.fee-info {
  .v-divider {
    margin: 6px 0;
    border-color: #f2f2f2;
  }

  .request-fee {
    cursor: pointer;

    > span {
      .icon {
        display: inline-block;
        margin-left: 4px;
      }
    }
  }

  .fee-info__item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    line-height: 32px;

    > span {
      color: #7a8189;
    }

    > div {
      font-weight: 500;
      color: #1a1a1a;
      display: inline-flex;

      img {
        margin-right: 9px;
      }
    }

    &.fee-total {
      // > span {
      //   color: #1a1a1a;
      //   font-weight: 500;
      //   font-size: 16px;
      // }
      .fee-info__tilte {
        display: block;

        > div {
          color: #1a1a1a;
          font-weight: 500;
          font-size: 16px;
        }

        > div:nth-child(2) {
          color: #7a8189;
          font-weight: 400;
          font-size: 13px;
          margin-top: -12px;
        }
      }

      > div {
        color: #ff8200;
        display: flex;
        align-items: center;
      }

      &.fee-other {
        > span {
          font-size: 12px;
          font-weight: 500;
        }
      }

      &.cod-total {
        > span {
          color: #1a1a1a;
          font-weight: 500;
        }
      }
    }
  }

  .fee-info__request-detail {
    padding: 12px;
    margin: 4px 0 12px;
    background-color: #f2f2f2;
    border-radius: 4px;

    .fee-info__request-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 13px;
      line-height: 20px;

      .fee-info__request-description {
        margin: 0;
      }

      &:not(:last-child) {
        margin-bottom: 4px;
      }

      > div:first-child {
        color: #7a8189;
      }

      > div:last-child {
        min-width: 60px;
        margin-left: 8px;
        text-align: right;
      }
    }
  }

  .discount-wrapper {
    margin: 12px 0;
  }

  .discount-title {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 4px;

    .discount-name {
      margin: 0;
      font-size: 14px;
      line-height: 20px;
      font-weight: 600;
      color: #121619;
    }
  }

  .discount-value {
    font-size: 14px;
    line-height: 20px;
    font-weight: 700 !important;
    color: #198038 !important;
  }
}
</style>

<style lang="scss">
.fee-info {
  .request-fee {
    > span {
      .icon {
        svg {
          path {
            fill: #7a8189;
          }
        }
      }
    }
  }
}
</style>
import { PAYMENT_METHODS } from '../mixins/constants'
